import React, { useRef, useEffect, useState } from "react";
import "../styles/VideoPlayerTags.css";

const VideoPlayerTags = ({ tags }) => {
  const tagsRef = useRef(null);
  const [tagList, setTagList] = useState([]);
  const [isLeftArrowVisible, setIsLeftArrowVisible] = useState(false);
  const [isRightArrowVisible, setIsRightArrowVisible] = useState(false);

  useEffect(() => {
    if (tags && Array.isArray(tags)) {
      const tagsWithProgress = tags.map((tag) => ({
        name: tag ? tag.trim() : "Unnamed Tag",
        progress: tag?.progress || 0,
      }));
      tagsWithProgress.sort((a, b) => b.progress - a.progress);
      setTagList(tagsWithProgress);
    }
  }, [tags]);

  const scrollRight = () => {
    tagsRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  const scrollLeft = () => {
    tagsRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const manageScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = tagsRef.current;

    setIsLeftArrowVisible(scrollLeft > 0);
    setIsRightArrowVisible(scrollLeft < scrollWidth - clientWidth);
  };

  useEffect(() => {
    const tagsElement = tagsRef.current;

    manageScroll();
    tagsElement.addEventListener("scroll", manageScroll);

    return () => tagsElement.removeEventListener("scroll", manageScroll);
  }, []);

  return (
    <div className="videoPlayer-video-tags-container">
      {isLeftArrowVisible && (
        <span className="videoPlayer-video-tag-left-arrow-active" onClick={scrollLeft}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </span>
      )}

      <div className="videoPlayer-video-tags" ref={tagsRef}>
        {tagList.map((tag, index) => (
          <span key={index} className="video-tag">
            {tag.name}
          </span>
        ))}
      </div>

      {isRightArrowVisible && (
        <span className="videoPlayer-video-tag-right-arrow-active" onClick={scrollRight}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </span>
      )}
    </div>
  );
};

export default VideoPlayerTags;
